module.exports = __webpack_public_path__ + "f55e28a8484a1e30796a6f5f078cdc96.svg";